import appGlobalScript from '/home/runner/work/kolibri/kolibri/packages/components/src/global/script.ts';
export const globalScripts = appGlobalScript;
export const globalStyles = "";
